import React from "react";
import "./refundPolicy.css";
import NavbarSection from "../../NavBar/Navbar.js";
import FooterSection from "../../NewFooter/Footer.js";

function RefundPolicy() {
  document.title = "3VO | Refund Policy";

  return (
    <div className="bg-pages">
      <NavbarSection />
      <div className="embed rapper-style">
        <div className="embed-container">
          <div className="embed-title">3VO Refund Policy</div>
          <div className="embed-date"></div>
          <div className="embed-privacy">
            <p>
              This Refund Policy (“Policy”) governs the circumstances under
              which 3VO Labs Ltd (“3VO,” “we,” “us,” or “our”) may, in its sole
              discretion, grant refunds or credits to users (“you,” “your,” or
              “User”) who purchase, earn, or otherwise acquire in-app
              currencies, subscriptions, or other paid features offered through
              the 3VO mobile or web applications, including 3VO Quest
              (“Services”). This Policy forms part of, and is fully incorporated
              into, the 3VO Terms of Use. Capitalized terms not defined here
              have the meanings set out in the Terms of Use.
              <br /> <br />
              Nothing in this Policy is intended to exclude or restrict any
              statutory rights to which you may be entitled under applicable
              consumer-protection laws; to the extent any provision of this
              Policy conflicts with such mandatory rights, that provision is
              deemed modified to the minimum extent necessary to comply with
              applicable law.
            </p>
            <br />
            1. Scope of the Policy
            <br />
            <p>
              a. This Policy applies to all transactions involving (i) in-app
              currencies (Diamonds, Energy, Rocket Fuel, Fragments, etc.), (ii)
              digital collectibles or Mystery Boxes, (iii) time-based
              subscriptions or paid plans, and (iv) any other paid feature or
              upgrade offered within 3VO Quest or other 3VO Services
              (collectively, “Paid Items”).
              <br />
              b. Transactions that occur on third-party platforms (e.g., Apple
              App Store, Google Play) are additionally subject to the refund
              rules of those platforms; you must submit applicable refund
              requests directly to the platform operator.
              <br />
              <br />
              2. General Principle: All Sales Final
              <br />
              Because Paid Items constitute (a) digital content delivered
              immediately or (b) consumable virtual items with no monetary or
              property value outside the 3VO ecosystem, all purchases and
              redemptions are deemed final and non-refundable once delivered to
              your account except as expressly set out in Section 4.
              <br />
              <br />
              3. No Cash Conversion
              <br />
              a. Paid Items—including Diamonds, Energy, Rocket Fuel, Fragments,
              or any similar in-app currency—have no cash or monetary value and
              may not be exchanged or redeemed for fiat currency, gift cards, or
              any other form of value outside the 3VO ecosystem.
              <br />
              <br />
              4. Limited Refund Eligibility
              <br />
              Subject to Section 6, we may in our sole discretion approve a
              refund or credit in the following limited circumstances:
              <br />
              Accidental Duplicate Purchase – You purchased the same Paid Item
              twice within 15 minutes due to an obvious technical or payment
              gateway error.
              <br /> Unauthorized Transaction – The purchase was not authorized
              by you (e.g., stolen payment credentials) and you provide a valid
              police report, bank dispute documentation, or other reasonable
              evidence.
              <br /> Non-Delivery of Paid Item – You were charged but the Paid
              Item failed to appear in your account within 24 hours and our
              support team confirms a system error. <br />
              Mandatory Statutory Right – If you reside in the European Economic
              Area or United Kingdom and (i) the Paid Item qualifies as “digital
              content” or a “service” under Directive (EU) 2019/770 or the UK
              Consumer Rights Act 2015, and (ii) performance has not yet begun,
              you may withdraw from the purchase within 14 days. However, by
              clicking “Buy,” “Claim,” or similar, you expressly request
              immediate delivery and acknowledge that your statutory withdrawal
              right is lost once delivery starts.
              <br /> No other circumstances—such as change of mind,
              dissatisfaction with in-app outcomes, loss of streaks, or unused
              balances—constitute grounds for a refund.
              <br />
              <br />
              5. Technical Disruptions
              <br />
              If a confirmed, system-wide outage or bug causes widespread
              erroneous charges, 3VO may, at its option, credit impacted
              accounts with equivalent in-app currency rather than process fiat
              refunds.
              <br />
              <br />
              6. Refund Procedure <br />
              To request a refund or credit, you must:
              <br />
              <br />
              Email info@3vo.me within seven (7) calendar days of the disputed
              transaction;
              <br />
              Include (i) your 3VO account ID or wallet address, (ii)
              transaction ID, date, and amount, (iii) payment method used, and
              (iv) the specific ground under Section 4 you believe applies; and
              Provide any evidence we reasonably request (screenshots, bank
              statements, police report, etc.).
              <br />
              We will acknowledge receipt within five (5) business days and
              endeavor to resolve the request within fifteen (15) business days,
              or thirty-five (35) business days in exceptional circumstances
              (e.g., suspected fraud). Our determination is final.
              <br />
              <br />
              7. Refund Method & Currency
              <br />
              a. Approved refunds for purchases processed through third-party
              app stores will be issued exclusively through those stores,
              subject to their timelines and terms.
              <br />
              b. Approved refunds for direct card or crypto payments will be
              credited to the same payment method and in the same currency
              originally used, minus non-recoverable network fees or processor
              charges.
              <br />
              c. Where a refund is impracticable (e.g., payment method closed),
              3VO may, at its discretion, credit the User’s 3VO account with an
              equivalent amount of in-app currency.
              <br />
              <br />
              8. Chargebacks & Disputed Payments
              <br />
              Initiating a chargeback or payment dispute without first following
              the procedure in Section 6 constitutes a breach of the Terms of
              Use. 3VO reserves the right to (i) suspend or terminate your
              account, (ii) recover the disputed amounts, and (iii) charge you
              any associated fees incurred by 3VO.
              <br />
              <br />
              9. Modification of this Policy We may modify or replace this
              Policy at any time. Material changes will be posted on the 3VO
              website or in-app. Your continued use of the Services after the
              effective date of any change constitutes acceptance of the revised
              Policy.
              <br />
              <br />
              10. Contact
              <br />
              For any questions about this Refund Policy, please contact:
              <br />
              <br />
              Email: info@3vo.me
              <br />
              Subject Line: Refund Policy Inquiry
              <br />
              <br />
              This Refund Policy is drafted in accordance with, and shall be
              interpreted under, the governing-law clause of the 3VO Terms of
              Use.
            </p>
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
}

export default RefundPolicy;
